module.exports = __webpack_public_path__ + "img/saveing.c9cc3582.png";